import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-knowledge-attrmapping',
    templateUrl: './knowledge-attrmapping.component.html',
    styleUrls: ['./knowledge-attrmapping.component.css']
})
export class KnowledgeAttrmappingComponent implements OnInit {
    // 头部搜索属性名称
    attrName = '';

    // 表格属性映射数据
    attrMapDatas = [
        {
            name: '本名',
            source: '百度百科',
            concept: '映射概念',
            attr: '映射字段',
            founder: '创建人',
            time: '2019-07-29 17：00：05'
        }
    ];

    // 表格是否显示加载中
    isLoading: boolean = false;

    // 表格分页组件
    pageBase: any = { orderBy: null }

    // 表格操作按钮
    toolbar = [
        { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
        { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: [] },
    ];
    constructor() { }

    ngOnInit() {
    }

    // 头部搜索查询按钮
    handleSelectClick() {

    }

    // 表格按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "add": this.handleAddClick(); break; // 新增
            case "delete": this.handleDeleteClick(); break;  // 删除
        }
    }

    // 新增属性
    handleAddClick() {

    }

    // 编辑属性
    handleEditClick() {

    }

    // 查看属性
    handleViewClick() {

    }

    // 删除属性
    handleDeleteClick() {

    }

    // 表格选中数据
    handleSelectData() {

    }

    // 表格分页
    handlePageClick() {
        
    }

}
